import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center justify-center text-center">
        <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>
        <p className="mt-6 font-heading text-5xl md:text-7xl font-bold text-foreground-950">404</p>
        <h1 className="mt-4 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
          这个页面暂时找不到
        </h1>
        <p className="mt-3 text-sm text-foreground-500 break-all">
          你访问的地址：{location.pathname}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/topics"
            className="px-6 py-3 rounded-md border border-foreground-300 text-sm font-medium text-foreground-800 whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer"
          >
            浏览话题库
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}